<template>
  <div class="col-lg-12 text-area-1 p-0">
    <label class="h5 text-area-1-label" :for="inputConfig.id">{{ inputConfig.title }}</label>
    <p v-html="inputConfig.description"></p>
    <input :id="inputConfig.id" class="form-control text-area-1-input" v-model="formAnswer[inputConfig.id]"
           ref="general_input_1"
           type="text"
           :placeholder="inputConfig.placeholder" :required="inputConfig.required"
    />
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "TextArea1",
  props: {
    inputConfig: {},
    formAnswer: {}
  },
  mounted() {
    let input = this.$refs.general_input_1
    let pattern = this.inputConfig.config.pattern
    if (pattern != '') {
      input.pattern = pattern
    }
  }
})
</script>

<style scoped>

</style>